import styles from './style.module.css';
import info from "../../../assets/info.svg";
import pickupdot from "../../../assets/pickupdot.svg";
import dropoffdot from "../../../assets/dropoffdot.svg";
import dropoffdone from "../../../assets/doneDropoff.svg";
import pickup_done from "../../../assets/pickup_done.svg";
import route_optimize from "../../../assets/route_optimize.svg";

import { useDispatch, useSelector } from 'react-redux';
import schedule from "../../../assets/schedule.svg";
import { checkTimestamp, get_calendarType, get_lang, get_timeFormat } from '../../../helper/UserData/userdate';
import _ from 'lodash';
import { OfferingDetailsOpen, PriceDetailsOpen, SetViewOrderPickupDropoffDetails, show_eventTimeLine } from '../../../Redux/actions/actionNames';
import React, { useCallback, useEffect } from 'react';
import clsx from 'clsx';
import { pickup_isPickuped } from '../../../helper/module';
import { useTranslation } from 'react-i18next';
import { OrderInfo, optimizeDropoffs_Http } from '../../../helper/api';
import { OrderInfoAction } from '../../../Redux/actions/actions';
import { snack } from '../../../utils/SnackbarUtilsConfigurator';
import Tag from '../../../design-system/lib/Tag';
import service_point from '../../../assets/service_point.svg';
import { calendar_time_gray, DONE_CIRCLE, ic_fail, TIMER } from '../../../assets';
import jalali from "jalali-moment";
import momentJalaali from "moment-jalaali";


export const PickupDropoffs = () => {
    const pickup = useSelector((state) => state.ViewTravel.pureData.pickup)
    const dropoff = useSelector((state) => state.ViewTravel.pureData.dropoff)
    const delivery = useSelector((state) => state.ViewTravel.pureData.delivery)

    const dropoffs = useSelector((state) => state.ViewTravel.pureData.dropoffs)
    const orderType = useSelector((state) => state.ViewTravel.pureData.type)
    const orderStatus = useSelector((state) => state.ViewTravel.pureData.status)
    const pureData = useSelector((state) => state.ViewTravel.pureData)
    const pickup_dropoff_details = useSelector((state) => state.ViewTravel.pickup_dropoff_details)
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();


    function reserveIsValid(data) {
        return data
            ? (data.scheduleDateBefore
                ? momentJalaali(data.scheduleDateBefore).isValid()
                : false) ||
            (data.scheduleDateAfter
                ? momentJalaali(data.scheduleDateAfter).isValid()
                : false)
            : false;
    }

    function reserveToText(data) {
        return momentJalaali(data.scheduleDateAfter || data.scheduleDateBefore).locale(get_lang()).format(checkTimestamp(data.scheduleDateAfter || data.scheduleDateBefore))
    }

    const pickupInfo = useCallback(() => {
        if (pickup_dropoff_details && String(pickup_dropoff_details.type) == "Pickup2") {
            dispatch(SetViewOrderPickupDropoffDetails(null))
        } else {
            dispatch(SetViewOrderPickupDropoffDetails({ type: "Pickup2", data: pickup }))
        }
        dispatch(OfferingDetailsOpen(false))
        dispatch(show_eventTimeLine(false))
        dispatch(PriceDetailsOpen(false))

    }, [pickup, pickup_dropoff_details]);

    const dropOffInfo = useCallback(() => {
        if (pickup_dropoff_details && String(pickup_dropoff_details.data.id) == String(dropoff.id)) {
            dispatch(SetViewOrderPickupDropoffDetails(null))
        } else {
            dispatch(SetViewOrderPickupDropoffDetails({ type: "Dropoff2", data: dropoff }))
        }
        dispatch(OfferingDetailsOpen(false))
        dispatch(show_eventTimeLine(false))
        dispatch(PriceDetailsOpen(false))

    }, [dropoff, pickup_dropoff_details]);


    const deliveryInfo = useCallback(() => {
        if (pickup_dropoff_details && String(pickup_dropoff_details.data.id) == "delivery") {
            dispatch(SetViewOrderPickupDropoffDetails(null))
        } else {
            dispatch(SetViewOrderPickupDropoffDetails({ type: "Dropoff2", data: {id:"delivery",...delivery} }))
        }
        dispatch(OfferingDetailsOpen(false))
        dispatch(show_eventTimeLine(false))
        dispatch(PriceDetailsOpen(false))

    }, [delivery, pickup_dropoff_details]);

    const odropOffInfo = useCallback((drop) => {
        if (pickup_dropoff_details && String(pickup_dropoff_details.data.id) == String(drop.id)) {
            dispatch(SetViewOrderPickupDropoffDetails(null))
        } else {
            dispatch(SetViewOrderPickupDropoffDetails({ type: "Dropoff2", data: drop }))
        }
        dispatch(OfferingDetailsOpen(false))
        dispatch(show_eventTimeLine(false))
        dispatch(PriceDetailsOpen(false))
    }, [pickup_dropoff_details]);


    const updatePickupDropOffDetails = useCallback(() => {


        if (pickup_dropoff_details && String(pickup_dropoff_details.type) != String("VehicleOptions")) {
            if (String(pickup_dropoff_details.type) == "Pickup2") {

                dispatch(SetViewOrderPickupDropoffDetails({ type: "Pickup2", data: pickup }))
            } else if (dropoff && String(pickup_dropoff_details.data.id) == String(dropoff.id)) {

                try {
                    dispatch(SetViewOrderPickupDropoffDetails({ type: "Dropoff2", data: dropoff }))
                } catch (error) {

                }
            } else if (String(pickup_dropoff_details.data.id) == String("delivery")) {

                try {
                    dispatch(SetViewOrderPickupDropoffDetails({ type: "Dropoff2", data: {id:"delivery",...delivery} }))
                } catch (error) {

                }
            } else {

                try {
                    let dropId = dropoffs.findIndex((drop => drop.id == pickup_dropoff_details.data.id));
                    let drop = dropoffs[dropId];

                    drop && dispatch(SetViewOrderPickupDropoffDetails({ type: "Dropoff2", data: drop }))
                } catch (error) {

                }
            }
        }

    }, [pickup, delivery, dropoff, dropoffs, pickup_dropoff_details]);


    useEffect(() => {

        updatePickupDropOffDetails()

    }, [pureData]);


    const canShowDropOffOptimize = useCallback(() => {
        if (["Ondemand"].indexOf(orderType) == 0 && dropoffs.length > 1) {
            if (["Unassigned", "Pending", "Assigned", "Started", "Arrived", "PickedUp"].indexOf(orderStatus) > -1) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }

    }, [orderType, orderStatus , dropoffs]);


    const handleDropOffOptimize = useCallback(() => {
        snack.info_i18("poperLoading")
        optimizeDropoffs_Http(dispatch, pureData.id, (call) => {
        })
    }, [dispatch, pureData]);



    const getTodayTomorowYesterday = React.useCallback((datexx) => {
        let date = new Date(datexx);

        let options = { hour: '2-digit', minute: '2-digit' };
        let timeString = date.toLocaleTimeString([], options);
        let startTime;

         return `${jalali(datexx).locale(get_lang()).format(checkTimestamp(datexx))}`;
 
    }, []);


    const dateIstoday = React.useCallback((datex) => {
        let datexxx = new Date(datex);

        let options = { hour: '2-digit', minute: '2-digit' };
        let startTime;

        if (datexxx.toDateString() == new Date().toDateString()) {
            return true
        }
        // if (date.toDateString() == new Date().toDateString()) {
        //     startTime = `${t("Start time")}: ${t("Today")} ${jalali(route.startDate).locale(get_lang()).format("HH:mm")}`;
        // } else if (date.toDateString()  == new Date(new Date().setDate(new Date().getDate() - 1)).toDateString()) {
        //     startTime = `${t("Start time")}: ${t("Yesterday")} ${jalali(route.startDate).locale(get_lang()).format("HH:mm")}`;
        // } else if (date.toDateString()  == new Date(new Date().setDate(new Date().getDate() + 1)).toDateString()) {
        //     startTime = `${t("Start time")}: ${t("Tomorrow")} ${jalali(route.startDate).locale(get_lang()).format("HH:mm")}`;
        // } else {
        //     startTime = `${t("Start time")}: ${jalali(route.startDate).locale(get_lang()).format("D MMM HH:mm")}`;
        // }

        return false
    }, []);



    // if (["PickupDelivery"].indexOf(orderType) > -1) {
    //     return null;
    // }

    return <div className={styles.DriverVehicle}>


        {!_.isEmpty(pickup) && <div className={styles.pdItem} style={{borderBottom : _.isEmpty(delivery) ? "" : "unset"}}>
            <img src={["PickupDelivery"].indexOf(orderType) > -1 ? pickupdot  : (pickup_isPickuped(pureData.status) ? pickup_done : pickupdot) } />
            <p className={styles.pdom}>
                <span className={clsx(styles.address, styles.pickup)}>{t("Pickup")} {pickup.locationType != "address" && <Tag size='Small' backgroundColor='GrayUltraLight' icon={service_point} text={t("Service point")} iconSize='14' weight='Body_Tiny_Regular' />}
                    {((pickup?.completeAfter || pickup?.completeAfter > 0) && !pickup?.realETA && !pickup?.stop?.statusUpdatedAt) && <Tag size='Small' backgroundColor='GrayUltraLight' icon={calendar_time_gray} text={`${getTodayTomorowYesterday(pickup?.completeAfter)} ${momentJalaali(pickup?.completeBefore).locale(get_calendarType()).format(` - ${get_timeFormat()}`)}`} iconSize='14' weight='Body_Tiny_Regular' />}
                    {( pickup?.realETA && (!pickup?.stop ||  ["Successful", "Failed"].indexOf(pickup?.stop?.status) == -1 )) && <Tag size='Small' backgroundColor='GrayUltraLight' icon={TIMER} text={`ETA: ${getTodayTomorowYesterday(pickup?.realETA)} `} iconSize='14' weight='Body_Tiny_Regular' />}
                    {( pickup?.stop  && ["Successful", "Failed"].indexOf(pickup?.stop?.status) > -1  ) && <Tag size='Small' backgroundColor='GrayUltraLight' icon={pickup?.stop?.status == "Successful" ? DONE_CIRCLE : ic_fail } text={pickup?.stop?.statusUpdatedAt  && `${getTodayTomorowYesterday(pickup?.stop?.statusUpdatedAt)} `} iconSize='14' weight='Body_Tiny_Regular' />}

                </span>
                   <span className={styles.address}>{pickup?.servicePoint?.name || pickup?.address}</span>
                   </p>
            {/* <span className={styles.address}>{pickup.address}</span> */}
            {reserveIsValid(pickup) && <span className={styles.scheduleContainer}> <img src={schedule} />{reserveToText(pickup)}</span>}
            <img className={clsx(styles.info, (pickup_dropoff_details && String(pickup_dropoff_details.type) == "Pickup2") && styles.infoActive)} src={info} onClick={pickupInfo} />
        </div>
        }
     {!_.isEmpty(dropoff) && <div className={styles.pdItem}>
            <img src={dropoff.status == "Done" ? dropoffdone : dropoffdot} />
            <p className={styles.pdom}>
            <span className={clsx(styles.address, styles.pickup)}>{t("Delivery")} {dropoff.locationType != "address" && <Tag size='Small' backgroundColor='GrayUltraLight' icon={service_point} text={t("Service point")} iconSize='14' weight='Body_Tiny_Regular' />}
                    {((dropoff?.completeAfter || dropoff?.completeAfter > 0) && !dropoff?.realETA && !dropoff?.stop?.statusUpdatedAt) && <Tag size='Small' backgroundColor='GrayUltraLight' icon={calendar_time_gray} text={`${getTodayTomorowYesterday(dropoff?.completeAfter)} ${momentJalaali(dropoff?.completeBefore).locale(get_calendarType()).format(` - ${get_timeFormat()}`)}`} iconSize='14' weight='Body_Tiny_Regular' />}
                    {( dropoff?.realETA && (!dropoff?.stop ||  ["Successful", "Failed"].indexOf(dropoff?.stop?.status) == -1 )) && <Tag size='Small' backgroundColor='GrayUltraLight' icon={TIMER} text={`ETA: ${getTodayTomorowYesterday(dropoff?.realETA)} `} iconSize='14' weight='Body_Tiny_Regular' />}
                    {( dropoff?.stop  && ["Successful", "Failed"].indexOf(dropoff?.stop?.status) > -1  ) && <Tag size='Small' backgroundColor='GrayUltraLight' icon={dropoff?.stop?.status == "Successful" ? DONE_CIRCLE : ic_fail } text={dropoff?.stop?.statusUpdatedAt  && `${getTodayTomorowYesterday(dropoff?.stop?.statusUpdatedAt)} `} iconSize='14' weight='Body_Tiny_Regular' />}

            </span> 

                   <span className={styles.address}>{dropoff?.servicePoint?.name || dropoff?.address}</span>
                   </p>
            {reserveIsValid(dropoff) && <span className={styles.scheduleContainer}> <img src={schedule} />{reserveToText(dropoff)}</span>}
            <img className={clsx(styles.info, (pickup_dropoff_details && String(pickup_dropoff_details.data.id) == String(dropoff.id)) && styles.infoActive)} src={info} onClick={dropOffInfo} />
        </div>} 
  
        {!_.isEmpty(delivery) &&<>
        <div style={{width:"100%",height:"6px",backgroundColor:"#F4F4F7",float:"inline-start"}}></div>
        <div className={styles.pdItem}>
            <img src={delivery.status == "Done" ? dropoffdone : dropoffdot} />
            <p className={styles.pdom}>
                    {["PickupDelivery"].indexOf(orderType) > -1 ? <span className={clsx(styles.address, styles.pickup)}>{t("Delivery")} 
                    {((delivery?.completeAfter || delivery?.completeAfter > 0) && !delivery?.realETA && !delivery?.stop?.statusUpdatedAt) && <Tag size='Small' backgroundColor='GrayUltraLight' icon={calendar_time_gray} text={`${getTodayTomorowYesterday(delivery?.completeAfter)} ${momentJalaali(delivery?.completeBefore).locale(get_calendarType()).format(` - ${get_timeFormat()}`)}`} iconSize='14' weight='Body_Tiny_Regular' />}
                    {( delivery?.realETA && (!delivery?.stop ||  ["Successful", "Failed"].indexOf(delivery?.stop?.status) == -1 )) && <Tag size='Small' backgroundColor='GrayUltraLight' icon={TIMER} text={`ETA: ${getTodayTomorowYesterday(delivery?.realETA)} `} iconSize='14' weight='Body_Tiny_Regular' />}
                    {( delivery?.stop  && ["Successful", "Failed"].indexOf(delivery?.stop?.status) > -1  ) && <Tag size='Small' backgroundColor='GrayUltraLight' icon={delivery?.stop?.status == "Successful" ? DONE_CIRCLE : ic_fail } text={delivery?.stop?.statusUpdatedAt  && `${getTodayTomorowYesterday(delivery?.stop?.statusUpdatedAt)}`} iconSize='14' weight='Body_Tiny_Regular' />}

                        </span> :  <span className={clsx(styles.address, styles.pickup)}>  {delivery.locationType != "address" && <Tag size='Small' backgroundColor='GrayUltraLight' icon={service_point} text={t("Service point")} iconSize='14' weight='Body_Tiny_Regular' />}
                        {((delivery?.completeAfter || delivery?.completeAfter > 0) && !delivery?.realETA && !delivery?.stop?.statusUpdatedAt) && <Tag size='Small' backgroundColor='GrayUltraLight' icon={calendar_time_gray} text={`${getTodayTomorowYesterday(delivery?.completeAfter)} ${momentJalaali(delivery?.completeBefore).locale(get_calendarType()).format(` - ${get_timeFormat()}`)}`} iconSize='14' weight='Body_Tiny_Regular' />}
                        {( delivery?.realETA && (!delivery?.stop ||  ["Successful", "Failed"].indexOf(delivery?.stop?.status) == -1 )) && <Tag size='Small' backgroundColor='GrayUltraLight' icon={TIMER} text={`ETA: ${getTodayTomorowYesterday(delivery?.realETA)} `} iconSize='14' weight='Body_Tiny_Regular' />}
                        {( delivery?.stop  && ["Successful", "Failed"].indexOf(delivery?.stop?.status) > -1  ) && <Tag size='Small' backgroundColor='GrayUltraLight' icon={delivery?.stop?.status == "Successful" ? DONE_CIRCLE : ic_fail } text={delivery?.stop?.statusUpdatedAt  && `${getTodayTomorowYesterday(delivery?.stop?.statusUpdatedAt)} `} iconSize='14' weight='Body_Tiny_Regular' />}

                    </span>}

                   <span className={styles.address}>{delivery?.servicePoint?.name || delivery?.address}</span>
                   </p>
            {/* <span className={styles.address}>{delivery.address}</span> */}
            {reserveIsValid(delivery) && <span className={styles.scheduleContainer}> <img src={schedule} />{reserveToText(delivery)}</span>}
            <img className={clsx(styles.info, (pickup_dropoff_details && String(pickup_dropoff_details.data.id) == String("delivery")) && styles.infoActive)} src={info} onClick={deliveryInfo} />
        </div>
        </> }
        

        {(!_.isEmpty(dropoffs) && dropoffs.length > 0) &&
            dropoffs.map((drop, i) => {
                return <> 
                        <div style={{width:"100%",height:"6px",backgroundColor:"#F4F4F7",float:"inline-start"}}></div>

                <div className={styles.pdItem}>
                    {dropoffs.length == 1 ? <img src={drop.status == "Done" ? dropoffdone : dropoffdot} /> : (drop.status == "Done" ? <img src={dropoffdone} /> : <span className={styles.dropNum}>{i+1}</span>)}
                    {/* {drop.status == "Done" ? <img src={dropoffdone} /> : <span className={styles.dropNum}>{i+1}</span> } */}
                    {/* <img src={drop.status == "Done" ? dropoffdone : dropoffdot} /> */}

                    <p className={styles.pdom}>
                    <span className={clsx(styles.address, styles.pickup)}>{t("Delivery")} {drop.locationType != "address" && <Tag size='Small' backgroundColor='GrayUltraLight' icon={service_point} text={t("Service point")} iconSize='14' weight='Body_Tiny_Regular' />}

                    </span> 


                   <span className={styles.address}>{drop?.servicePoint?.name || drop?.address}</span>
                   </p>
                    {reserveIsValid(drop) && <span className={styles.scheduleContainer}> <img src={schedule} />{reserveToText(drop)}</span>}
                    <img className={clsx(styles.info, (pickup_dropoff_details && String(pickup_dropoff_details.data.id) == String(drop.id)) && styles.infoActive)} src={info} onClick={() => { odropOffInfo(drop) }} />
                </div></>
            })
        }

        {canShowDropOffOptimize() && <div className={styles.routeOptimize} onClick={handleDropOffOptimize}>
            <img src={route_optimize} alt="" />
            <span>{t("OptimizeDropoffs")}</span>
        </div>}



    </div>

};




